import React, { Fragment } from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { IoMdHelpCircle } from 'react-icons/io';
import { ConditionActionDetails } from './ConditionActionDetails';
import { DisplayMode, TranslatedStringActionDetail } from './components/TranslatedStringActionDetail';
import { NPCActionDetail } from './components/NPCSelectionActionDetail';
import { FaMinusCircle, FaPlusCircle } from 'react-icons/fa';
import { ActionEditorChangeGroup, groupUndoableActionEditorChanges } from '../../../stores/undo/operation/ActionEditorSubmitChangesOp';
import { TextFormatInfoPopup } from "../TextFormatInfoPopup";
import { getTreeParent } from '../../../../shared/action/ActionTreeModel';
import { ElementGroup, ElementGroupContainer } from './components/BaseElements';
import { BooleanActionDetail } from './components/BooleanActionDetail';
const DeleteButton = styled.button.withConfig({
  displayName: "StartDialogueActionDetails__DeleteButton",
  componentId: "sc-1qms97x-0"
})(["float:right;color:#DD0000;font-size:10px;border:0;"]);
const FormattingHelpButtonContainer = styled.div.withConfig({
  displayName: "StartDialogueActionDetails__FormattingHelpButtonContainer",
  componentId: "sc-1qms97x-1"
})(["float:right;margin-right:8px;"]);
const HelpIcon = styled(IoMdHelpCircle).withConfig({
  displayName: "StartDialogueActionDetails__HelpIcon",
  componentId: "sc-1qms97x-2"
})(["vertical-align:bottom;font-size:18px;"]);
const DialogueAnswer = observer(({
  index,
  exit,
  remove
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(ElementGroupContainer, null, /*#__PURE__*/React.createElement(DeleteButton, {
    onClick: remove
  }, /*#__PURE__*/React.createElement(FaMinusCircle, null)), /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: index + 1 + ". " + t("action_editor.property_answer"),
    translatedString: exit.value,
    displayMode: DisplayMode.CommentAndGenders,
    allowBlankValue: false
  }), /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.hide_condition"),
    checked: Boolean(exit.hideCondition),
    toggle: exit.toggleHideConditionActive.bind(exit)
  }), exit.hideCondition && /*#__PURE__*/React.createElement(ConditionActionDetails, {
    condition: exit.hideCondition
  }));
});
export const StartDialogueActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormattingHelpButtonContainer, null, /*#__PURE__*/React.createElement(TextFormatInfoPopup, {
    showTextStyleOptions: true
  })), /*#__PURE__*/React.createElement(NPCActionDetail, {
    name: t("action_editor.property_speaker"),
    selectedNPC: action.speaker,
    npcSetter: action.setSpeaker.bind(action),
    allowBlankValue: true,
    parentTree: getTreeParent(action)
  }), action.speaker && typeof action.speaker === "string" && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", null, "Vorheriger Sprecher-Name: ", action.speaker)), /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("action_editor.property_text_neutral"),
    translatedString: action.text,
    displayMode: DisplayMode.CommentAndGenders,
    allowBlankValue: false
  }), action.answers.map((answer, index) => /*#__PURE__*/React.createElement(Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement(DialogueAnswer, {
    index: index,
    exit: answer,
    remove: () => groupUndoableActionEditorChanges(ActionEditorChangeGroup.UnspecificGroupedNodeChanges, () => action.removeAnswer(index))
  }))), /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement("button", {
    onClick: action.addAnswer.bind(action)
  }, /*#__PURE__*/React.createElement(FaPlusCircle, null), " ", t("action_editor.property_answer"))));
});